/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getNDCDetails,
  setCurrentNDCDetailsIndex,
  setCurrentNDCDetailsSelected,
  setNDCErrorPopupMessage,
  setNDCLoading,
  setNDCSuccessMessage
} from '../../../store/action';

export const ArrowComponent = ({ component, onClick, className }) => {
  return (
    <div
      className={`round-icon-container ${className || ''}`}
      onClick={onClick}
      tabIndex={0}
    >
      {component}
    </div>
  );
};

const NDCDetailsPagination = () => {
  const [paginationIndex, setPaginationIndex] = useState(1);

  const currentNDCDetailsIndex = useSelector(
    (state) => state.sharedState.ndc.currentNDCDetailsIndex
  );

  const ndcDetails = useSelector((state) => state.sharedState.ndc.ndcDetails);
  const dispatch = useDispatch();

  useEffect(() => {
    setPaginationIndex(currentNDCDetailsIndex);
  }, [currentNDCDetailsIndex]);

  const callNDCDetailsAPI = async (index) => {
    dispatch(setNDCErrorPopupMessage(null));
    if (ndcDetails.length > 0) {
      dispatch(setNDCLoading(true));
      const response = await getNDCDetails([ndcDetails[index - 1]]);
      dispatch(setNDCLoading(false));
      if (response) {
        dispatch(setCurrentNDCDetailsIndex(index));
        dispatch(setCurrentNDCDetailsSelected(response[0],'All'));
      } else {
        showErrorPopup('Something went wrong.');
      }
    }
  };

  const handleNextAndPrevClick = (isNext = true) => {
    dispatch(setNDCSuccessMessage(null));
    
    const index = currentNDCDetailsIndex + (isNext ? 1 : -1);

    if (parseInt(index) < 1 || parseInt(index) > ndcDetails.length) {
    } else {
      callNDCDetailsAPI(parseInt(index));
    }
  };

  const showErrorPopup = (message) => {
    dispatch(setNDCErrorPopupMessage(message));
    setPaginationIndex(currentNDCDetailsIndex);
  };

  const onTextEnterPress = (e) => {
    if (e.keyCode === 13) {
      handlePaginateBlur();
    }
  };

  const handlePaginateBlur = () => {
    if (!paginationIndex) {
      showErrorPopup('Please input a numeric value only');
    } else if (parseInt(paginationIndex) === 0) {
      showErrorPopup('Please input a positive number');
    } else if (parseInt(paginationIndex) > ndcDetails.length) {
      showErrorPopup('Please input a number less than total page');
      setPaginationIndex(currentNDCDetailsIndex);
    } else if (parseInt(paginationIndex) !== currentNDCDetailsIndex) {
      callNDCDetailsAPI(parseInt(paginationIndex));
    }
  };
  const getTotalPages = () => {
  return ndcDetails.length > 1000 ? 1000 : ndcDetails.length;
};


  return (
    <div className="d-flex align-items-center justify-content-end">
      <ArrowComponent
        className="mr-2"
        component={
          <i className="fa fa-light fa-caret-left" aria-hidden="true" />
        }
        onClick={() => handleNextAndPrevClick(false)}
      />
      <span id="navigation">Page</span>

      <div className="mui-custom-form with-select pagination-text-field">
        <TextField
          type="string"
          value={paginationIndex}
          onKeyDown={onTextEnterPress}
          style={{ maxWidth: '55px' }}
          inputProps={{
            'aria-labelledby': 'navigation',
          }}
          onChange={(e) => {
            if (/^[0-9]+$/g.test(e.target.value)) {
              setPaginationIndex(e.target.value);
            } else if (e.target.value === '') {
              setPaginationIndex('');
            }
          }}
          onBlur={() => {
            handlePaginateBlur();
          }}
        />
      </div>
      <span>{`of ${getTotalPages() === 0 ? 1 : getTotalPages()}`}</span>
      <ArrowComponent
        className="mt-0 ml-2"
        component={
          <i className="fa fa-light fa-caret-right" aria-hidden="true" />
        }
        onClick={() => handleNextAndPrevClick()}
      />
    </div>
  );
};

export default NDCDetailsPagination;
